module.exports = __webpack_public_path__ + "img/pt.30bd0662.png";